import { useContext, useEffect } from "react";
import AuthContext from "./AuthContext";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";

const ProtectedRoute = ({ children }) => {
  const authContext = useContext(AuthContext);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  if (window.location.hash) {
    localStorage.setItem(
      "ad-callback-data",
      JSON.stringify(
        Object.fromEntries(new URLSearchParams(window.location.hash.substr(1))),
      ),
    );
  }

  useEffect(() => {
    if (activeAccount) {
      authContext.loginAuth();
    }
  }, []); //, [authContext]);

  // return <>{authContext.checkUserToken() && authContext.authenticated ? children : <Navigate to="/login" replace state={{ path: location.pathname }} />}</>;
  return (
    <>
      {activeAccount ? (
        <AuthenticatedTemplate> {children} </AuthenticatedTemplate>
      ) : (
        <p>&nbsp;</p>
      )}
    </>
  );
};
export default ProtectedRoute;
